var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mt-4 td-4"},[_c('div',{staticClass:"col-md-12"},[_c('h3',{staticClass:"report-title text-center"},[_vm._v(_vm._s(_vm.title))])])]),_c('Breadcrumb'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }